"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BidForm_vue_1 = __importDefault(require("@/Views/Components/Project/Pages/Item/Show/BidForm.vue"));
var PayNowBanner_vue_1 = __importDefault(require("@/Views/Components/Project/Pages/Item/Show/PayNowBanner.vue"));
var Gallery_vue_1 = __importDefault(require("@/Views/Components/Project/Pages/Item/Show/Gallery.vue"));
var BidCount_vue_1 = __importDefault(require("@/Views/Components/Project/Pages/Item/Show/BidCount.vue"));
var ToggleWatching_vue_1 = __importDefault(require("@/Views/Components/Project/Misc/Item/ToggleWatching.vue"));
var BiddingHistory_vue_1 = __importDefault(require("@/Views/Components/Project/Pages/Item/Show/BiddingHistory.vue"));
var Description_vue_1 = __importDefault(require("@/Views/Components/Project/Pages/Item/Show/Description.vue"));
var Countdown_vue_1 = __importDefault(require("@/Views/Components/Project/Misc/Item/Countdown.vue"));
var vue_1 = __importDefault(require("vue"));
var vue_class_component_1 = __importDefault(require("vue-class-component"));
var vue_property_decorator_1 = require("vue-property-decorator");
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var route_1 = __importDefault(require("@/Modules/Misc/route"));
var routes_1 = require("@/routes");
var toastNotification_1 = __importDefault(require("@/Modules/Misc/toastNotification"));
var currency = require("currency.js");
var props = {
    item: { type: Object, required: true },
    bankIsActive: {
        type: Boolean,
        required: true
    },
    permissions: {
        type: Object,
        required: true
    }
};
var components = {
    BidForm: BidForm_vue_1.default,
    PayNowBanner: PayNowBanner_vue_1.default,
    ToggleWatching: ToggleWatching_vue_1.default,
    Gallery: Gallery_vue_1.default,
    Countdown: Countdown_vue_1.default,
    BidCount: BidCount_vue_1.default,
    BiddingHistory: BiddingHistory_vue_1.default,
    Description: Description_vue_1.default
};
var ItemShowPage = /** @class */ (function (_super) {
    __extends(ItemShowPage, _super);
    function ItemShowPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemShowPage.prototype.currencyFormat = function (arg) {
        return currency(arg).format();
    };
    Object.defineProperty(ItemShowPage.prototype, "strippedContent", {
        get: function () {
            var tmp = document.createElement("DIV");
            tmp.innerHTML = this.item.content;
            return tmp.textContent || tmp.innerText || "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemShowPage.prototype, "bids", {
        get: function () {
            return lodash_1.default.orderBy(this.item.bids, ['amount'], ['desc']);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemShowPage.prototype, "itemEditRoute", {
        get: function () {
            return (0, route_1.default)(routes_1.EDIT_ITEM_PAGE, { item: this.item.hash_id, board: this.item.board.abbr });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemShowPage.prototype, "itemArchiveRoute", {
        get: function () {
            return (0, route_1.default)(routes_1.ITEM_ARCHIVE_PAGE, { board: this.item.board.abbr });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemShowPage.prototype, "itemIndexRoute", {
        get: function () {
            return (0, route_1.default)(routes_1.ADMIN_ITEM_INDEX_PAGE, { board: this.item.board.abbr });
        },
        enumerable: false,
        configurable: true
    });
    ItemShowPage.prototype.formatDate = function (date, format) {
        if (format === void 0) { format = null; }
        return (0, moment_1.default)(date).format(format);
    };
    ItemShowPage.prototype.autoRefreshPage = function () {
        var _this = this;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
            _this.$inertia.reload({
                only: [
                    'item',
                    'pageMessage'
                ]
            });
            _this.autoRefreshPage();
        }, this.item.item_show_refresh_rate);
    };
    ItemShowPage.prototype.onPageMessageChanged = function (to, from) {
        if (to.message && from) {
            (0, toastNotification_1.default)(this.$toast, to.message, to.messageColor, {
                timeout: 10000,
                hideProgressBar: false,
                position: "top-center"
            });
        }
    };
    ItemShowPage.prototype.mounted = function () {
        this.autoRefreshPage();
    };
    ItemShowPage.prototype.beforeDestroy = function () {
        clearTimeout(this.timeout);
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: true, type: Object })
    ], ItemShowPage.prototype, "item", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: false, type: Object })
    ], ItemShowPage.prototype, "flash", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: false, type: Object })
    ], ItemShowPage.prototype, "pageMessage", void 0);
    __decorate([
        (0, vue_property_decorator_1.Watch)('pageMessage', { immediate: true, deep: true })
    ], ItemShowPage.prototype, "onPageMessageChanged", null);
    ItemShowPage = __decorate([
        (0, vue_class_component_1.default)({
            components: components,
            props: props,
        })
    ], ItemShowPage);
    return ItemShowPage;
}(vue_1.default));
exports.default = ItemShowPage;
